import { isMobile } from './is-mobile';
// To be removed on 51993 clean up
export const isBexSplitView = (context, experiments) => {
  var _a, _b;
  if (!context || !experiments || isMobile(context)) {
    return false;
  }
  return ((_b = (_a = experiments.exposures) === null || _a === void 0 ? void 0 : _a.Split_View_Side_by_side_BEXG_H) === null || _b === void 0 ? void 0 : _b.bucket) === 1;
};